<template>
  <mds-input
    v-model="email"
    :label="label"
    :placeholder="translate('scheduler.modal.delivery.email.placeholder')"
    :error="!!error.length"
    :error-text="[error]"
  />
</template>

<script>
import MdsInput from '@mds/input'
import isEmpty from 'lodash/isEmpty'
import MwcBaseHelpersMixin from '@morningstar/mcl-utilities/src/vue/mixins/mwc-base-mixin'
import defaultConfig from '@/components/schedulerModal/config/i18n'

export default {
  name: 'EmailField',
  components: { MdsInput },
  mixins: [MwcBaseHelpersMixin],
  props: {
    label: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default: /* istanbul ignore next */ () => [],
    },
    editedFeed: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      defaultConfig,
      email: '',
      error: [],
    }
  },
  created() {
    if (this.editedFeed && this.editedFeed.delivery_destination) {
      this.email = !Number.isInteger(this.editedFeed.delivery_destination)
        ? this.editedFeed.delivery_destination
        : ''
    }
    this.$emit('disable-save-button', true)
    this.$emit('input', { delivery_destination: this.email })
  },
  watch: {
    email: {
      handler: 'validateEmailValue',
    },
  },
  methods: {
    validateEmail() {
      return new Promise((resolve) => {
        if (this.options) {
          setTimeout(() => {
            const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
            resolve(this.email.length && !re.test(this.email))
          }, 100)
        }
      })
    },
    async validateEmailValue() {
      const invalidEmail = await this.validateEmail()
      await this.$nextTick()

      const CONDITIONS = {
        [isEmpty(this.email)]: this.translate(
          'scheduler.modal.delivery.empty.email.error'
        ),
        [invalidEmail]: this.translate(
          'scheduler.modal.delivery.invalid.email.error'
        ),
      }

      if (
        this.email.includes(',') ||
        this.email.includes(';') ||
        this.email.includes(' ')
      ) {
        this.error = this.translate(
          'scheduler.modal.delivery.multiple.email.error'
        )
      } else {
        this.error = CONDITIONS[true] || []
      }

      if (!invalidEmail) {
        this.$emit('input', { delivery_destination: this.email })
      }
      this.$emit('disable-save-button', !isEmpty(this.error))
    },
  },
}
</script>
